<template>
  <div class="agancy-product-list-module">
    <div v-if="modalOpened" class="madalbackground" @click="closeModals"></div>

    <div v-if="modalSecondOpened" class="madalSecondbackground" @click="closeSecondModals"></div>

    <div class="container">
      <transition tag="div" name="fade">
        <div class="mandatory-modal pb-1" v-if="descModal">

          <div class="desc">
            <img v-if="itemImage" :src='`https://kishoto.ir/dtr/approid/img/${itemImage}`'>

            <div class="title">
              <p>{{ itemName }}</p>

              <div class="price-box"><p> {{ itemPrice | toPersianCurrency("",0) }}</p> <p class="currency">تومان</p></div>

            </div>

            <div class="buy-ticket">
              <p>خرید بلیط</p>
            </div>

            <div class="choose-ticket d-flex flex-row justify-content-around mt-4 text-center" v-if="itemDateTimes">

                <div class="count-box">
                  <p>تعداد بلیط</p>
                  <div class="upcount changevalue" @click="increaseProductCount(itemId,itemDesc,itemImage,itemName,itemPlace,itemPrice,itemDateTimes,itemKey)"><chevron-up-icon></chevron-up-icon></div>
                  <div class="countboxinput d-flex justify-content-center"><div class="countinginput d-flex align-items-center justify-content-center">{{products[itemKey].count}}</div></div>
                  <div class="downcount changevalue" @click="decreaseProductCount(itemId,itemDesc,itemImage,itemName,itemPlace,itemPrice,itemDateTimes,itemKey)"><chevron-down-icon></chevron-down-icon></div>

                </div>

              <div class="select-date-box">
                <p>انتخاب تاریخ و زمان</p>
                <div class="inputSelect select-date" @click="openDateSelectModal(itemDateTimes)">{{ selectedDate }}</div>
                <div class="inputSelect select-time" @click="openTimesModal">{{ selectedTime }}</div>
              </div>


            </div>

            <div class="choose-ticket d-flex flex-row justify-content-around mt-4 text-center" v-else>

              <div class="count-box">
                <p>تعداد بلیط</p>

                <div class="upcount changevalue" @click="increaseProductCount(itemId,itemDesc,itemImage,itemName,itemPlace,itemPrice,itemDateTimes,itemKey)"><chevron-up-icon></chevron-up-icon></div>
                <div class="countboxinput d-flex justify-content-center"><div class="countinginput d-flex align-items-center justify-content-center">{{products[itemKey].count}}</div></div>
                <div class="downcount changevalue" @click="decreaseProductCount(itemId,itemDesc,itemImage,itemName,itemPlace,itemPrice,itemDateTimes,itemKey)"><chevron-down-icon></chevron-down-icon></div>

              </div>

              <div class="desc-box">
                <p class="mt-3 p-2" v-html="itemDesc"  style="text-align: justify"></p>
              </div>

            </div>

            <div class="price-bottom-box"><p> {{ (products[itemKey].total_price === itemPrice && products[itemKey].count === 0 ) ? 0 : products[itemKey].total_price | toPersianCurrency("",0) }}</p> <p class="currency">تومان</p></div>

            <button class="btn btn-outline-primary mb-3 mx-auto d-flex justify-content-center mr-2 mb-2 w-80" @click="closeDescModal">
              تایید و بستن
            </button>

            <br>
            <p v-if="itemDateTimes" class="mt-1 p-3" v-html="itemDesc"></p>

          </div>


        </div>
      </transition>
    </div>

   <!-- select date modal-->
    <div class="container">
      <transition tag="div" name="fade">
        <div class="second-modal pb-1" v-if="dateModal">

          <div class="title-date-container">
            <div class="select-date">
              <p>انتخاب تاریخ</p>
            </div>

            <div class="date-tickets-items">
                <div class="date-ticket-item" v-for="itemDate in itemDateTimes" @click="clickDateTicket(itemDate.cdate,itemDate.count,itemDate.times)">
                      {{itemDate.cdate}}
                </div>
            </div>

          </div>

        </div>
      </transition>
    </div>
    <!-- select date modal-->

    <!-- select time modal-->
    <div class="container">
      <transition tag="div" name="fade">
        <div class="second-modal pb-1" v-if="timeModal">

          <div class="title-date-container">
            <div class="select-date">
              <p>انتخاب زمان</p>
            </div>

            <div class="date-tickets-items">
              <div class="date-ticket-item" v-for="itemTime in ticketTimes" @click="clickTimeTicket(itemTime.id,itemTime.time,itemTime.count)">
                {{itemTime.time}}
                <span style="color:red">
             موجودی:    {{itemTime.count}} بلیط
                </span>
              </div>
            </div>

          </div>

        </div>
      </transition>
    </div>
    <!-- select time modal-->



    <div class="container">
      <transition tag="div" name="fade">
        <div class="mandatory-modal pt-1 pb-1" v-if="submitModal">
          <div class="submit-title">
            <p>تایید نهایی خرید</p>
          </div>

          <div class="desc">
            <div class="items-selected mt-4">

                <div class="item-selected" v-for="item in final_data">
                    <p>{{item.count}} * {{item.name}} -- {{item.price * item.count | toPersianCurrency("تومان",0)}}</p>
                </div>

            </div>

            <p class="mt-3 text-center alarmticket">زمان انقضای بلیط سه روز پس از دریافت</p>
            <div class="final-price-box">{{final_price | toPersianCurrency("تومان",0) }}</div>
          </div>

          <div class="btn-container-payment d-flex flex-row justify-content-evenly">
            <button class="onlinepay" @click="paymentRequest(0)">پرداخت آنلاین</button>
            <button class="walletpay" @click="paymentRequest(1)">پرداخت با اعتبار</button>
          </div>

          <button class="btn btn-outline-danger mb-3 mx-auto d-flex justify-content-center mr-2 mb-2 w-80" @click="closeSubmitModal">
            بستن
          </button>
        </div>
      </transition>
    </div>

    <div class="container-fluid mainboxcontainer p-0">
      <div class="topbar-fixed">
       <h5 style="direction: rtl;">{{ title }}</h5>
      </div>
      <div class="table-container">
            <div v-for="(item,key) in products" :key="item.id" class="item-row-agency" :style="{backgroundImage:`url(https://kishoto.ir/dtr/approid/img/${item.image})` }" @click="openProductDescModal(item.id,item.name,item.des,item.image,item.price,item.place,item.date_times,item.count,item,key)">

              <div class="back-gradient">

                <div class="name-box">
                  <p class="name">{{ item.name }}</p>
                  <p class="categoryname">{{ item.place }}</p>
                </div>

                <div class="price-box"><p> {{ item.price | toPersianCurrency("",0) }}</p> <p class="currency">تومان</p></div>
                <div v-if="item.count != 0" class="btn-danger btn" type="button">حذف</div>

                <div class="ticket-selected-box" v-if="item.count != 0 && item.cdate == null">
                  {{item.count}}

                  بلیط

                  به مبلغ
                  {{ item.total_price | toPersianCurrency("",0) }}

                </div>

                <div class="ticket-selected-box" v-else-if="item.count != 0 && item.cdate != null">
                  {{item.count}}

                  بلیط

                  برای

                  {{item.cdate}}

                  ساعت

                  {{item.time}}

                  به مبلغ
                  {{ item.total_price | toPersianCurrency("",0) }}
                  <!--
                                  <div class="price-box"><p> </p></div>
                  -->
                </div>

              <!--<td class="count-td">

                <div class="count-box">

                  <div class="upcount changevalue" @click="increaseProductCount(item.id,item.name,item.place,item.price,key)"><chevron-up-icon></chevron-up-icon></div>
                  <div class="countboxinput d-flex justify-content-center"><div class="countinginput d-flex align-items-center justify-content-center">{{item.count}}</div></div>
                  <div class="downcount changevalue" @click="decreaseProductCount(item.id,item.name,item.place,item.price,key)"><chevron-down-icon></chevron-down-icon></div>

                </div>

              </td>
              <td>
                <div class="desc-box" >
                 <message-text-icon />
                  <p>توضیحات</p>
                </div>
              </td>-->
              </div>
            </div>
      </div>
      <div class="btn-container">
        <button @click="openSubmitModal">مرحله بعد</button>
      </div>
    </div>
  </div>
</template>

<script>
import MessageTextIcon from 'vue-material-design-icons/MessageText';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown';
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp';

import store from "@/store";

export default {
  data() {
    return {
      title: "",
      products: null,
      final_data: [],
      final_price: 0,

      modalOpened:false,
      modalSecondOpened:false,

      descModal:false,
      submitModal:false,
      dateModal:false,
      timeModal:false,

      itemImage:null,
      itemId:null,
      itemDesc:null,
      itemName:null,
      itemPrice:null,
      itemPlace:null,
      itemDateTimes:null,
      itemKey:null,
      item:null,

      dateSelected: false,
      timeId:null,
      ticketTimes:null,
      ticketLimit:null,

      selectedDate:"انتخاب تاریخ",
      selectedTime:"انتخاب ساعت"
    };
  },
  components:{
    MessageTextIcon,
    ChevronDownIcon,
    ChevronUpIcon
  },
  created() {
    this.getProductList();
    this.getTitle();
  },
  methods: {
    async getProductList() {
      let fd = new FormData();
      fd.append("agency_id", this.$route.params.id);
      const response = await this.$ApiServiceLayer.post("agency_products", fd);

      // console.log(response);
      this.products = response.list;
      this.products.map((item,index)=>{
          item.count = 0;
          item.total_price = item.price;
          item.cdate = null;
          item.time = null;
      });
      //this.products
    },
    async getTitle() {
      const response = await this.$ApiServiceLayer.post("agency_list");
      response.list.forEach((item) => {
        if (item.id === this.$route.params.id) {
          this.title = item.name;
        }
      });
    },
    openProductDescModal(id,name,des,image,price,place,datetimes,count,item,key){
      console.log(count);
      if(count != 0){
        this.removeItem(item,key);
        //return false;
      }else{
        this.itemId = id;
        this.itemName = name;
        this.itemImage = image;
        this.itemDesc = des;
        this.itemPrice = price;
        this.itemPlace = place;
        this.itemDateTimes = datetimes;
        this.itemKey = key;

        this.descModal = true;
        this.modalOpened = true;
      }
    },
    closeDescModal(){
      this.descModal = false;
      this.modalOpened = false;

      this.dateSelected =  false;
      this.timeId = null;
      this.ticketTimes = null;
      this.ticketLimit = null;
      this.selectedDate = "انتخاب تاریخ";
      this.selectedTime = "انتخاب ساعت";
    },
    closeModals(){
        this.descModal = false;
        this.modalOpened = false;
        this.submitModal = false;
        this.dateModal = false;


      this.dateSelected =  false;
      this.timeId = null;
      this.ticketTimes = null;
      this.ticketLimit = null;
      this.selectedDate = "انتخاب تاریخ";
      this.selectedTime = "انتخاب ساعت";

    },

    closeSecondModals(){
      //this.descModal = false;
      //this.modalOpened = false;
     // this.submitModal = false;
      this.dateModal = false;
      this.timeModal = false;
      this.modalSecondOpened = false;
    },

    closeSubmitModal(){
      this.submitModal = false;
      this.modalOpened = false;
      this.dateModal = false;
    },
    openDateSelectModal(){
      this.dateModal = true;
      this.modalSecondOpened = true;

      this.timeId = null;
      this.dateSelected = false;
      this.ticketLimit = null;
      this.ticketTimes = null;
      this.selectedTime = "انتخاب ساعت";

      if(this.final_data !== null) {
        this.final_data.map((item, index) => {
          if (item.pid === this.itemId) {
            this.final_data.splice(index, 1);

            this.$set(this.products,this.itemKey,{
              id:this.itemId,
              cdate:null,
              time:null,
              image:this.itemImage,
              name:this.itemName,
              place:this.itemPlace,
              count:0,
              price: this.itemPrice,
              total_price:0,
              date_times:this.itemDateTimes
            });
          }
        });
      }

    },
    clickTimeTicket(id,time,count){

      this.timeId = id;
      this.ticketLimit = count;
      this.selectedTime = time;

      this.dateModal = false;
      this.modalSecondOpened = false;
      this.timeModal = false;


      if(this.final_data !== null) {
        this.final_data.map((item, index) => {
          if (item.pid === this.itemId) {
              this.final_data.splice(index, 1);

            this.$set(this.products,this.itemKey,{
              id:this.itemId,
              cdate:null,
              time:null,
              image:this.itemImage,
              name:this.itemName,
              place:this.itemPlace,
              count:0,
              price: this.itemPrice,
              total_price:0,
              date_times:this.itemDateTimes
            });
          }
        });
      }
    },
    clickDateTicket(cdate,count,times){

      this.selectedDate = cdate;
      this.ticketLimit = count;
      this.ticketTimes = times;

      this.dateModal = false;
      this.modalSecondOpened = false;
      this.dateSelected = true;

      if(this.final_data !== null) {
        this.final_data.map((item, index) => {
          if (item.pid === this.itemId) {
            this.final_data.splice(index, 1);

            this.$set(this.products,this.itemKey,{
              id:this.itemId,
              cdate:null,
              time:null,
              image:this.itemImage,
              name:this.itemName,
              place:this.itemPlace,
              count:0,
              price: this.itemPrice,
              total_price:0,
              date_times:this.itemDateTimes
            });
          }
        });
      }

    },
    openTimesModal(){
      if(!this.dateSelected){
        this.$toast.open({
          message: 'لطفا ابتدا تاریخ را انتخاب کنید.',
          type: 'error',
        });

          return false;
      }

      if(this.final_data !== null) {
        this.final_data.map((item, index) => {
          if (item.pid === this.itemId) {
            this.final_data.splice(index, 1);

            this.$set(this.products,this.itemKey,{
              id:this.itemId,
              cdate:null,
              time:null,
              image:this.itemImage,
              name:this.itemName,
              place:this.itemPlace,
              count:0,
              price: this.itemPrice,
              total_price:0,
              date_times:this.itemDateTimes
            });
          }
        });
      }

      this.dateModal = false;
      this.timeModal = true;
      this.modalSecondOpened = true;



    },
    openSubmitModal(){
      if(!store.state.login.loginTempToken){
        this.$toast.open({
          message: 'برای خرید بلیط نیاز به ثبت نام دارید',
          type: 'info',
        });
        setTimeout(()=> {
          this.$router.push("/login");
        },1000);
      }else{
        let sumprice = 0;
        if(this.final_data.length > 0){

          this.final_data.map((item,index)=>{
             sumprice += item.price*item.count;
          });

          this.final_price = sumprice;

          this.submitModal = true;
          this.modalOpened = true;
        }else{
          this.$toast.open({
            message: 'لطفا حداقل یک بلیط را انتخاب نمایید',
            type: 'error',
          });
        }

      }
    },

    async paymentRequest(is_credit){
      if(is_credit === 0) {
        this.$toast.open({
          message: 'لطفا تا ورود به درگاه منتظر باشید',
          type: 'info',
        });
      }
      this.loading = true;
      let newfinaldata = [];
      this.final_data.map((item,index)=>{
        newfinaldata.push({
          pid:item.pid,
          count: item.count,
          time_id: typeof item.time_id !== "undefined" ? item.time_id : "-"
        });
      });
      let fd = new FormData();
      fd.append("token", store.state.login.loginTempToken);
      fd.append("data",JSON.stringify(newfinaldata));
      fd.append("final_price",this.final_price );
      fd.append("is_credit",is_credit);


      const response = await this.$ApiServiceLayer.post("agency_products_payment", fd);

      if (response) {

        if(is_credit === 0){
          this.$toast.clear();
          this.$toast.open({
            message: 'به درگاه بانک منتقل میشوید',
            type: 'success',
          });

          this.loading = false;

        setTimeout(()=>{
          window.open(response.pay_url,'_self');
        },1000);

          }else{

          if(response.status_code === 200){
            this.$toast.open({
              message: "پرداخت شما با موفقیت انجام شد",
              type: 'success',
            });

            setTimeout(()=> {
              this.$router.push("/profile/history");
            },1000);
          }
          if(response.status_code === 521){
            this.$toast.open({
              message: response.msg,
              type: 'error',
            });
          }

        }
      }
        /*this.$toast.open({
          message: 'مشکلی در دریافت اطلاعات پیش آمده است',
          type: 'error',
        });
        this.loading = false;*/

    },

    increaseProductCount(id,description,image,name,des,price,dateTimes,key){

      let similar = false;
      let counts = 0;

      console.table(dateTimes);

      if(dateTimes !== null){
        console.log("Increase DateTime is not null!");
        if(this.timeId === null){
          this.$toast.open({
            message: 'لطفا ابتدا تاریخ و ساعت را انتخاب کنید.',
            type: 'error',
          });
            return false;
        }


        if(this.final_data !== null) {
          console.log("hear1");

          this.final_data.map((item,index)=>{

            if(item.pid === id){
              if(this.ticketLimit != item.count){
                  console.log("it is hear: "+ id);
                  item.pid = id;
                  item.count++;
                  counts = item.count;
                  //this.products[key].count++;
                  //this.$set(this.products.count, key, this.products[key].count+1);
                  similar = true;
              }else{
                this.$toast.open({
                  message: 'شما بیشترین تعداد بلیط مجاز را انتخاب نموده اید.',
                  type: 'error',
                });
                similar = true;
                counts = item.count;
                item.pid = id;
              }
            }
          });



          if(similar === false){
            console.log("similar false");
            //this.products[key].count = 1;
            this.$set(this.products,key,{
              id:id,
              des:description,
              cdate:this.selectedDate,
              time: this.selectedTime,
              name:name,
              image:image,
              place:des,
              count:1,
              price:price,
              total_price:price,
              time_id:this.timeId,
              date_times:dateTimes
            });
            this.final_data.push({
              pid:id,
              name:name,
              time_id:this.timeId,
              count:1,
              price:price
            });
          }else{
            this.$set(this.products,key,{
              id:id,
              name:name,
              cdate:this.selectedDate,
              time: this.selectedTime,
              des:description,
              image:image,
              time_id:this.timeId,
              place:des,
              count:counts,
              price:price,
              total_price:price*counts,
              date_times:dateTimes
            });
          }

        }else{

          this.$set(this.products,key,{
            id:id,
            name:name,
            cdate:this.selectedDate,
            time: this.selectedTime,
            des:description,
            time_id:this.timeId,
            image:image,
            place:des,
            count:1,
            price:price,
            total_price:price,
            date_times:dateTimes
          });

          this.final_data.push({
            pid:id,
            name:name,
            time_id:this.timeId,
            count:1,
            price:price
          });
        }

        console.log("final hear");
        console.log(this.final_data);
      }else{
        if(this.final_data !== null) {
          console.log("hear1");

          this.final_data.map((item,index)=>{


            if(item.pid === id){

              /*if(this.ticketLimit == item.count){
                return false;
              }*/

              console.log("it is hear: "+ id);
              item.pid = id;
              item.count++;
              counts = item.count;
              //this.products[key].count++;
              //this.$set(this.products.count, key, this.products[key].count+1);
              similar = true;
            }
          });



          if(similar === false){
            console.log("similar false");
            //this.products[key].count = 1;
            this.$set(this.products,key,{
              id:id,
              name:name,
              cdate:null,
              time:null,
              des:description,
              image:image,
              place:des,
              count:1,
              price:price,
              total_price:price,
              date_times:dateTimes
            });
            this.final_data.push({
              pid:id,
              name:name,
              count:1,
              price:price
            });
          }else{
            this.$set(this.products,key,{
              id:id,
              name:name,
              cdate:null,
              time:null,
              des:description,
              image:image,
              place:des,
              count:counts,
              price:price,
              total_price:price*counts,
              date_times:dateTimes
            });
          }

        }else{

          console.log("First time");
          this.$set(this.products,key,{
            id:id,
            name:name,
            cdate:null,
            time:null,
            des:description,
            image:image,
            place:des,
            count:1,
            price:price,
            total_price:price,
            date_times:dateTimes
          });

          this.final_data.push({
            pid:id,
            name:name,
            count:1,
            price:price
          });
        }

        console.log("final hear");
        console.log(this.final_data);
      }

    },
    decreaseProductCount(id,description,image,name,des,price,dateTimes,key){

      let similar = false;
      let counts = 0;

      if(!dateTimes){

      if(this.final_data !== null) {

        this.final_data.map((item,index)=>{
          if(item.pid === id){

            if(this.ticketLimit == item.count){
              return false;
            }


            console.log("it is hear: "+ id);

            if(item.count >= 1){
              item.count--;
               counts = item.count;

              this.$set(this.products, key, {
                id: id,
                cdate:this.selectedDate,
                time: this.selectedTime,
                image: image,
                name: name,
                des:description,
                place: des,
                count: counts,
                price: price,
                total_price: price * counts,
                date_times:dateTimes
              });

            }

            if(item.count === 0){
              this.final_data.splice(index, 1);

              this.$set(this.products,key,{
                id:id,
                cdate:this.selectedDate,
                time: this.selectedTime,
                image:image,
                name:name,
                des:description,
                place:des,
                count:0,
                price:price,
                total_price:price,
                date_times:dateTimes
              });
            }
            similar = true;
          }
        });

        if(similar === false){
          console.log("similar is false");
          /*this.final_data.push({
            pid:id,
            name:name,
            count:1,
            price:price
          });*/
        }

      }else{
        console.log("First time decrease noting");
      }
      console.log("final dec hear");
      console.log(this.final_data);

      }else{
        console.log("Decrease DateTime is not null!");
        if(this.timeId === null){
          this.$toast.open({
            message: 'لطفا ابتدا تاریخ و ساعت را انتخاب کنید.',
            type: 'error',
          });
          return false;
        }


        if(this.final_data !== null) {

          this.final_data.map((item,index)=>{
            if(item.pid === id){
              console.log("it is hear: "+ id);

             /* if(this.ticketLimit === item.count){
                return false;
              }*/

              if(item.count >= 1){
                item.count--;
                counts = item.count;

                this.$set(this.products, key, {
                  id: id,
                  cdate: null,
                  time: null,
                  image: image,
                  name: name,
                  des:description,
                  time_id: this.timeId,
                  place: des,
                  count: counts,
                  price: price,
                  total_price: price * counts,
                  date_times:dateTimes
                });

              }

              if(item.count === 0){
                this.final_data.splice(index, 1);

                this.$set(this.products,key,{
                  id:id,
                  cdate: null,
                  time: null,
                  image:image,
                  name:name,
                  des:description,
                  time_id: this.timeId,
                  place:des,
                  count:0,
                  price:price,
                  total_price:price,
                  date_times:dateTimes
                });
              }
              similar = true;
            }
          });

          if(similar === false){
            console.log("similar is false");
            /*this.final_data.push({
              pid:id,
              name:name,
              count:1,
              price:price
            });*/
          }

        }else{
          console.log("First time decrease noting");
        }
        console.log("final dec hear");
        console.log(this.final_data);


      }

    },
    removeItem(item,key){
      if(this.final_data !== null) {
        this.final_data.map((itemfinal, index) => {
          if (itemfinal.pid == item.id) {
            this.final_data.splice(index, 1);
            this.$set(this.products,key,{
              id: item.id,
              cdate:null,
              time:null,
              image:item.image,
              name:item.name,
              place:item.place,
              count: 0,
              price: item.price,
              total_price:0,
              date_times:item.date_times
            });
          }
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.agancy-product-list-module {
  width: 100%;
  height: auto;
  padding: 0px;
.mainboxcontainer{
  margin-bottom: 5rem;
  .topbar-fixed{
    position: fixed;
    width: 100%;
    height: 42px;
    background: #ffffff;
    top: 0;
    border-bottom:1px solid grey;
    z-index: 2;
      h5{
        padding-top: 0px;
        margin-top: 10px;
        font-size: 17px;
        background: white;
        width: 100%;
        color: grey;
      }
  }
}
  .mandatory-modal {
    position: fixed;
    min-height: 308px;
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0px;
    direction: rtl;
    z-index: 2;
    overflow-y: scroll;
    overflow-x: hidden;
    border: 1px dashed #80808033;
    .title {
      width: 100%;
      height: 100%;
      margin-top: 0;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #8bc34a;
      color: #ffff;
      align-items: center;
      padding: 9px 12px 8px 12px;
      p{
        margin-bottom: 0;
      }

      .price-box{
        display: flex;
        flex-direction: row;
        font-weight: bold;
        .currency{
          font-weight: normal !important;
          margin-right: 7px;
        }
      }
    /*  p {
        //position: absolute;
        padding: 10px 20px;
        background-color: rgb(255, 255, 255);
        font-family: "sansb";
        top: -20px;
        right: 5%;
      }*/
    }

    .submit-title{
      width: 100%;
      height: 3px;
      background-color: blue;
      margin-top: 40px;
      text-align: center;
      position: relative;
      p {
        position: absolute;
        padding: 10px 20px;
        background-color: rgb(255, 255, 255);
        font-family: "sansb";
        top: -20px;
        right: 5%;
      }
    }

    .desc {
      width: 100%;
      padding: 0px;
      text-align: right;
      //margin-top: 20px;

      img{
        width:100%;
      }

      .final-price-box{
        width: 100%;
        border: 1px solid #808080a6;
        padding: 11px;
        text-align: center;
        border-radius: 5px;
        font-weight: bold;
        font-size: 16px;
      }

      p {
        font-family: "sans";
        font-size: 14px;
        line-height: 28px;
      }

      .buy-ticket {
        width: 100%;
        height: 1px;
        background-color: blue;
        margin-top: 40px;
        text-align: center;
        position: relative;
        p {
          position: absolute;
          padding: 10px 7px;
          background-color: rgb(255, 255, 255);
          font-family: "sansb";
          top: -20px;
          right: 42%;
        }
      }
      .count-box{
         width: 30%;
        .countinginput{
          width: 43px;
          border-radius: 10px;
          border: 0.3px solid gray;
          height: 40px;
          text-align: center;
          font-weight: bold;
        }
        .changevalue{
          span{
            font-size: 24px;
            padding: 0 !important;
            font-weight: bold;
          }
        }
        .upcount{

        }
        .downcount{

        }
      }
      .select-date-box{
        width: 70%;
        padding: 6px 6px 9px 14px;
        .inputSelect{
          border: 1px solid #263238;
          border-radius: 10px;
          padding: 9px 5px 9px 5px;
          margin-bottom: 5px;
          font-weight: bold;
        }
      }
      .desc-box{
        width: 70%;
      }

      .price-bottom-box{
        display: flex;
        flex-direction: row;
        text-align: center;
        justify-content: center;
        p{
          padding: 10px 8px 9px 2px;
          font-size: 17px;
        }
        .currency{
          color: gray;
          font-size: 17px;
        }
      }
    }
    .btn-container-payment {
      bottom: 30px;
      width: 100%;
      height: 60px;
      left: 0;
      padding: 10px;
      .onlinepay{
        background-color: #8BC34A;
        width: 46%;
      }
      .walletpay{
        background-color: #536DFE;
        width: 46%;
      }
      button {
        font-size: 17px;
        height: 105%;
        border-radius: 10px;
        border: none;
        color: #fff;
        font-family: "sans";
        font-weight: 500;
      }
    }

  }

  .second-modal {
    position: fixed;
    min-height: 200px;
    width: 88%;
    background-color: #fff;
    border-radius: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0px;
    direction: rtl;
    z-index: 4;
    overflow-y: scroll;
    overflow-x: hidden;
    border: 1px dashed #80808033;
    .title-date-container {

      .select-date{
        width: 100%;
        height: 1px;
        background-color: #9c27b0;
        margin-top: 40px;
        text-align: center;
        position: relative;
        p {
          position: absolute;
          padding: 10px 7px;
          background-color: rgb(255, 255, 255);
          font-family: "sansb";
          top: -20px;
          right: 36%;
        }
      }
    }

    .date-tickets-items{
      text-align: center;
      margin-top: 26px;
      .date-ticket-item{
        padding: 10px 5px 10px 5px;
        font-weight: bold;
        font-size: 17px;
        display: flex;
        flex-direction: column;
      }
    }
/*    .title-date-container {
      width: 100%;
      height: 100%;
      margin-top: 0;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #8bc34a;
      color: #ffff;
      align-items: center;
      padding: 9px 12px 8px 12px;
      p{
        margin-bottom: 0;
      }
      .select-date{

       }
    }*/

    .submit-title{
      width: 100%;
      height: 3px;
      background-color: blue;
      margin-top: 40px;
      text-align: center;
      position: relative;
      p {
        position: absolute;
        padding: 10px 20px;
        background-color: rgb(255, 255, 255);
        font-family: "sansb";
        top: -20px;
        right: 5%;
      }
    }

    .desc {
      width: 100%;
      padding: 0px;
      text-align: right;
      //margin-top: 20px;

      img{
        width:100%;
      }


      p {
        font-family: "sans";
        font-size: 14px;
        line-height: 28px;
      }

    }
  }

  h5 {
    width: 100%;
    text-align: center;
    font-family: "sans";
    margin-top: 20px;
    font-weight: bold;
    font-size: 17px;
  }
  .btn-container {
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 65px;
    left: 0;
    padding: 0 6px 16px 6px;
    background: white;

    button {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      border: none;
      background-color: #8BC34A;
      color: #fff;
      font-family: "sans";
    }
  }

  .table-container {
    width: 100%;
    margin-top: 40px;

.item-row-agency{
  text-align: right;
  background-size: 100% !important;
  background-repeat: no-repeat !important;
  background-position: center !important;

  .back-gradient{
    background: linear-gradient(
            71deg
        , rgba(38, 50, 56, 0) 9%, #ffffffe0 56%) !important;
    width: 100%;
    height: 100%;
    padding: 10px 12px 9px 7px !important;
  .desc-box  {
    span{
      font-size: 19px;
    }
    p{
      transform: scale(0.7);
    }
  }

  .price-box{
    text-align: center;
    display: flex;
    flex-direction: row-reverse;
    .currency{
      transform: scale(0.8);
      color:#A2A2A2;
    }
  }

  .name-box{
    text-align: right;
    .name {
      font-size: 13px;
      //transform: scale(0.9);
      //font-weight: bold;
    }
    .categoryname{
      //transform: scale(0.7);
      //position: absolute;

    }
  }
    .ticket-selected-box{
      background: #8BC34A;
      color: #ffffff;
      padding: 5px;
      direction: rtl;
      border-radius: 11px;
    }
  }
}



    table {
      direction: rtl;
      width: 100%;
      table-layout: fixed;
      thead {
        width: 100%;
        border-bottom: 1px solid gray;
        tr {
          margin-bottom: 10px;
          th {
            padding: 10px 0;
            text-align: center;
            font-family: "sans";
            font-weight: normal;
            font-size: 12px;
            color: #9e9e9e;
            transform: scale(0.8);
          }
        }
      }
      tbody {
        tr {
          border-bottom: 1px solid gray;
          td {
            text-align: center;
            padding: 10px 0;
            font-family: "sans";
            font-size: 12px;
            p {
              font-size: 12px;
              margin-bottom: 0;
              font-family: "sans";
            }



          }
        }
      }
    }
  }

  .madalbackground{
    width: 100%;
    height:100%;
    top: 0;
    background: #0000006e;
    position: fixed;
    z-index: 1;
  }

  .madalSecondbackground{
    width: 100%;
    height:100%;
    top: 0;
    background: #0000006e;
    position: fixed;
    z-index: 3;
  }
}

@media all and (min-width:600px) {
  .mandatory-modal.pb-1 .desc img {
    width: 25% !important;
    height: 35% !important;
    margin: 0 auto;
    display: flex;
    margin-top: 63px;
  }
}
</style>
